import React, { useState, useEffect } from "react";
import Announcement from "./view/_announcement-banner"
import AnnouncementPopup from "./view/_announcement-popup"
import { useDispatch, useSelector } from "react-redux";
import { announcements } from "./model/announcement-action";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
   margin:{
       marginTop:"73px"
   },
   nomargin:{
    ['@media (max-width:321px)']: {
        marginTop:"8px"
    },
    ['@media (max-width:1024px)']: {
        marginTop:"0px"
    },   
   }
  })); 

export default function AnnouncementBanner(props) {
    const Classes = useStyles();
    const languageCode = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
    const customerClass=useSelector((state) => state?.accountInformation?.personAcccountDetail?.personAccountList?.[0]?.customerClassCd);
    const announcementDetails = useSelector((state) =>state?.announcementReducer?.annResults?.data?.getAnnouncementList);
    const dispatch = useDispatch();
    useEffect(() => {
        if (!announcementDetails) {
                if (languageCode) {
                    (async () => {
                        await dispatch(announcements(languageCode, customerClass));
                    })();
                }
        }
    }, [languageCode, customerClass, announcementDetails]);

        let margin= localStorage.getItem("announcementMargin")

    return (
        <div className={margin?Classes.margin : Classes.nomargin}>
          <Announcement />
           <AnnouncementPopup />
        </div> 
    );
}
